module.exports = __webpack_public_path__ + "static/media/google-white.862a91a2.svg";